enum FeatureStatusIntent {
  draft = 'warning',
  active = 'positive',
  archived = 'neutral',
}

export default FeatureStatusIntent;
